import { render, staticRenderFns } from "./aspage.vue?vue&type=template&id=78068a6f&scoped=true"
import script from "./aspage.vue?vue&type=script&lang=js"
export * from "./aspage.vue?vue&type=script&lang=js"
import style0 from "./aspage.vue?vue&type=style&index=0&id=78068a6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78068a6f",
  null
  
)

export default component.exports